module.exports = __webpack_public_path__ + "static/media/Close.f4a6db5e.svg";